

import { useQuery } from "@tanstack/react-query";
import type { SellerListResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseAdminSellersQueryParams = {
  limit?: number;
  offset?: number;
  q?: string;
};

function buildPath(params: UseAdminSellersQueryParams) {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  if (params.q) {
    query.set("q", params.q);
  }

  const queryString = query.toString();
  return queryString.length > 0
    ? `${endpoints.admin.sellers}?${queryString}`
    : endpoints.admin.sellers;
}

export function useSellersQuery(params: UseAdminSellersQueryParams = {}) {
  const query = useQuery({
    queryKey: queryKeys.admin.sellers(params),
    queryFn: () => apiJsonClient<SellerListResponse>(buildPath(params)),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
